module.exports = __webpack_public_path__ + "public/StoreIcon/payout.svg?fcd410c7";